export default __webpack_public_path__ + "static/media/shea1.271510db.jpg";